import { CALCULATE_CHUNKED_ROW_KEYS, INCREMENT_PAGE_COUNT, RESET_PAGE_COUNT } from "../actions/pagination";
import { calculatePaginatedDataKeys } from "../../utils/data.transformations/paginatedDataKeys";

const initialImmutablePaginationState = {
    rowsPerPage: 30,
};

export function immutablePagination(state = initialImmutablePaginationState, action) {
    return state
}


const initialMutablePaginationState = {
    pageCount: 1,
    chunkedReadOnlyRowKeys: [],
    chunkedEditableRowKeys: [],
};

export function mutablePagination(state = initialMutablePaginationState, action) {
    switch (action.type) {

        case INCREMENT_PAGE_COUNT:
            return {
                ...state,
                pageCount: state.pageCount += 1
            };

        case RESET_PAGE_COUNT:
            return {
                ...state,
                pageCount: initialMutablePaginationState.pageCount
            };

        case CALCULATE_CHUNKED_ROW_KEYS:

            const readOnlyRowKeys = action.initialRowKeys.filter(rowKey => !action.editableRowKeys.includes(rowKey));
            const editableRowKeys = action.initialRowKeys.filter(rowKey => action.editableRowKeys.includes(rowKey));

            return {
                ...state,
                chunkedReadOnlyRowKeys: calculatePaginatedDataKeys(
                    readOnlyRowKeys,
                    initialImmutablePaginationState.rowsPerPage
                ),
                chunkedEditableRowKeys: calculatePaginatedDataKeys(
                    editableRowKeys,
                    initialImmutablePaginationState.rowsPerPage
                )
            };

        default:
            return state
    }
}
